import React from 'react';
import { ShieldAlert, Sparkles, Sliders, X } from 'lucide-react';
import { GatewayConfig } from '../types';

interface SetupBannerProps {
  config: GatewayConfig;
  onOpenConfig: () => void;
  onDismiss: () => void;
  dismissed: boolean;
}

export const SetupBanner: React.FC<SetupBannerProps> = ({
  config,
  onOpenConfig,
  onDismiss,
  dismissed,
}) => {
  if (dismissed) return null;

  const isNoToken = !config.bearerToken;

  return (
    <div className="bg-gradient-to-r from-amber-500/10 via-purple-500/10 to-cyan-500/10 border-b border-amber-500/20 px-4 py-2.5 sm:px-6">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-xs">
        <div className="flex items-center gap-2.5">
          <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-amber-500/20 text-amber-400 border border-amber-500/30">
            {isNoToken ? <ShieldAlert className="w-3.5 h-3.5" /> : <Sparkles className="w-3.5 h-3.5" />}
          </span>
          <div>
            <span className="font-semibold text-amber-300">
              {isNoToken ? 'Gateway Authentication Pending' : 'Simulation Mode Active'}
            </span>
            <span className="text-slate-400 ml-1.5 hidden md:inline">
              {isNoToken
                ? 'Bearer token is not configured. Dashboard is operating with realistic synthetic telemetry for demo and testing.'
                : 'Synthetic telemetry stream active. You can connect directly to your live gateway at any time.'}
            </span>
          </div>
        </div>

        <div className="flex items-center gap-2 w-full sm:w-auto justify-end">
          <button
            onClick={onOpenConfig}
            className="flex items-center gap-1.5 px-3 py-1 rounded bg-amber-500/20 hover:bg-amber-500/30 text-amber-300 border border-amber-500/40 font-medium transition-colors cursor-pointer"
          >
            <Sliders className="w-3.5 h-3.5" />
            <span>Configure Gateway & Token</span>
          </button>
          <button
            onClick={onDismiss}
            aria-label="Dismiss banner"
            className="p-1 rounded text-slate-400 hover:text-slate-200 hover:bg-slate-800/60 transition-colors cursor-pointer"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
